// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/doyen_access/prism.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessHero {
  display: flex;
  gap: 8em;
}@media (max-width: 767px) {.accessHero {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
}@media (min-width: 768px) and (max-width: 1024px) {.accessHero {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
}.accessHero {

  .left_div {
    display: grid;
  }

  .left_div {
    width: 50%;
  }

  .left_div {
    gap: 1rem;
  }

  @media (min-width: 768px) and (max-width: 1024px) {.left_div {
      width: 100%;
    }
  }

  .left_div {

    h2 {
      font-size: 40px;
    }

    h2 {
      font-weight: 700;
    }

    @media (max-width: 767px) {h2 {
        font-size: 28px;
      }
    }

    button {
      display: flex;
    }

    button {
      height: 48px;
    }

    button {
      align-items: center;
    }

    button {
      gap: 0.25rem;
    }

    button {
      border-radius: 9999px;
    }

    button {
      --tw-bg-opacity: 1;
      background-color: rgb(54 126 62 / var(--tw-bg-opacity, 1));
    }

    button {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    button {
      font-weight: 700;
    }

    button {
      --tw-text-opacity: 1;
      color: rgb(255 255 255 / var(--tw-text-opacity, 1));
    }

    p {
      width: 480px;
    }

    p {
      font-weight: 400;
    }

    .accessText {
      height: 36px;
    }

    .accessText {
      width: 131px;
    }

    .accessText {
      border-radius: 9999px;
    }

    .accessText {
      --tw-bg-opacity: 1;
      background-color: rgb(222 255 226 / var(--tw-bg-opacity, 1));
    }

    .accessText {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }

    .accessText {
      text-align: center;
    }

    .accessText {
      font-size: 16px;
    }

    .accessText {
      font-weight: 700;
    }

    .accessText {
      --tw-text-opacity: 1;
      color: rgb(54 126 62 / var(--tw-text-opacity, 1));
    }
  }

  .right_div {
    position: relative;
  }

  .right_div {
    width: 50%;
  }

  .right_div {
    border-radius: 1.5rem;
  }

  .right_div {
    --tw-bg-opacity: 1;
    background-color: rgb(247 247 247 / var(--tw-bg-opacity, 1));
  }

  .right_div {
    padding: 48px;
  }

  @media (max-width: 767px) {.right_div {
      display: flex;
    }
  }

  @media (max-width: 767px) {.right_div {
      width: 140vw;
    }
  }

  @media (max-width: 767px) {.right_div {
      flex-direction: column;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {.right_div {
      display: flex;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {.right_div {
      width: 100%;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {.right_div {
      flex-direction: column;
    }
  }

  .right_div {

    .review_div {
      display: flex;
    }

    .review_div {
      width: 100%;
    }

    .review_div {
      align-items: flex-end;
    }

    .review_div {
      justify-content: space-between;
    }

    button {
      display: flex;
    }

    button {
      height: 48px;
    }

    button {
      width: 192px;
    }

    button {
      align-items: center;
    }

    button {
      gap: 0.5rem;
    }

    button {
      border-radius: 9999px;
    }

    button {
      border-width: 1px;
    }

    button {
      --tw-border-opacity: 1;
      border-color: rgb(54 126 62 / var(--tw-border-opacity, 1));
    }

    button {
      padding-left: 1rem;
    }

    button {
      --tw-text-opacity: 1;
      color: rgb(54 126 62 / var(--tw-text-opacity, 1));
    }
  }

  .right_div::after {
    content: "";
    position: absolute;
    top: -3em;
    right: 3em;
    bottom: 0;
    width: 230px;
    height: 230px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    z-index: 1;
  }
}

@media (max-width: 768px) {
  .right_div::after {
    display: none;
  }
}

@media (max-width: 1024px) {
  .right_div::after {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/doyenAccess/components/hero/doyenAccessHero.css"],"names":[],"mappings":"AACE;EAAA,aAAiF;EAAjF;AAAiF,CAAjF,2BAAA;IAAA,aAAiF;IAAjF,WAAiF;IAAjF;EAAiF;AAAA,CAAjF,mDAAA;IAAA,aAAiF;IAAjF,WAAiF;IAAjF;EAAiF;AAAA,CADnF;;EAII;IAAA;EAAiC;;EAAjC;IAAA;EAAiC;;EAAjC;IAAA;EAAiC;;EAAjC,mDAAA;MAAA;IAAiC;EAAA;;EADnC;;IAII;MAAA;IAA2C;;IAA3C;MAAA;IAA2C;;IAA3C,2BAAA;QAAA;MAA2C;IAAA;;IAI3C;MAAA;IAA2F;;IAA3F;MAAA;IAA2F;;IAA3F;MAAA;IAA2F;;IAA3F;MAAA;IAA2F;;IAA3F;MAAA;IAA2F;;IAA3F;MAAA,kBAA2F;MAA3F;IAA2F;;IAA3F;MAAA,oBAA2F;MAA3F;IAA2F;;IAA3F;MAAA;IAA2F;;IAA3F;MAAA,oBAA2F;MAA3F;IAA2F;;IAI3F;MAAA;IAA4B;;IAA5B;MAAA;IAA4B;;IAI5B;MAAA;IAAyG;;IAAzG;MAAA;IAAyG;;IAAzG;MAAA;IAAyG;;IAAzG;MAAA,kBAAyG;MAAzG;IAAyG;;IAAzG;MAAA,mBAAyG;MAAzG;IAAyG;;IAAzG;MAAA;IAAyG;;IAAzG;MAAA;IAAyG;;IAAzG;MAAA;IAAyG;;IAAzG;MAAA,oBAAyG;MAAzG;IAAyG;EAE7G;;EAGE;IAAA;EAAsH;;EAAtH;IAAA;EAAsH;;EAAtH;IAAA;EAAsH;;EAAtH;IAAA,kBAAsH;IAAtH;EAAsH;;EAAtH;IAAA;EAAsH;;EAAtH,2BAAA;MAAA;IAAsH;EAAA;;EAAtH,2BAAA;MAAA;IAAsH;EAAA;;EAAtH,2BAAA;MAAA;IAAsH;EAAA;;EAAtH,mDAAA;MAAA;IAAsH;EAAA;;EAAtH,mDAAA;MAAA;IAAsH;EAAA;;EAAtH,mDAAA;MAAA;IAAsH;EAAA;;EADxH;;IAII;MAAA;IAA4C;;IAA5C;MAAA;IAA4C;;IAA5C;MAAA;IAA4C;;IAA5C;MAAA;IAA4C;;IAI5C;MAAA;IAA0G;;IAA1G;MAAA;IAA0G;;IAA1G;MAAA;IAA0G;;IAA1G;MAAA;IAA0G;;IAA1G;MAAA;IAA0G;;IAA1G;MAAA;IAA0G;;IAA1G;MAAA;IAA0G;;IAA1G;MAAA,sBAA0G;MAA1G;IAA0G;;IAA1G;MAAA;IAA0G;;IAA1G;MAAA,oBAA0G;MAA1G;IAA0G;EAE9G;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,mDAAwD;IACxD,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".accessHero {\n  @apply flex gap-[8em] sm:flex sm:flex-col sm:w-full md:flex md:flex-col md:w-full;\n\n  .left_div {\n    @apply w-1/2 grid gap-4 md:w-full;\n\n    h2 {\n      @apply text-[40px] font-bold sm:text-[28px];\n    }\n\n    button {\n      @apply flex gap-1 items-center bg-[#367E3E] text-white rounded-full px-2 h-[48px] font-bold;\n    }\n\n    p {\n      @apply font-normal w-[480px];\n    }\n\n    .accessText {\n      @apply text-[16px] font-bold text-[#367E3E] bg-[#DEFFE2] rounded-full w-[131px] text-center py-2 h-[36px];\n    }\n  }\n\n  .right_div {\n    @apply bg-[#F7F7F7] w-1/2 p-[48px] rounded-3xl relative sm:flex sm:flex-col md:flex md:flex-col md:w-full sm:w-[140vw];\n\n    .review_div {\n      @apply flex w-full items-end justify-between;\n    }\n\n    button {\n      @apply text-[#367E3E] border border-[#367E3E] rounded-full flex gap-2 items-center w-[192px] h-[48px] pl-4;\n    }\n  }\n\n  .right_div::after {\n    content: \"\";\n    position: absolute;\n    top: -3em;\n    right: 3em;\n    bottom: 0;\n    width: 230px;\n    height: 230px;\n    background: url(\"/public/images/doyen_access/prism.svg\");\n    background-repeat: no-repeat;\n    z-index: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .right_div::after {\n    display: none;\n  }\n}\n\n@media (max-width: 1024px) {\n  .right_div::after {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
